// extracted by mini-css-extract-plugin
export default {"actions":"activity_matches-module___actions___f1e76753"};